import React from 'react';
import classNames from 'classnames';
import { Button } from '../../button';

import { numberToBengali } from '../../../utils/convertToBengaliNumber';
import Page from './Page';
import MidPage from './MidPage';

const MAX_PAGE_WITHOUT_BREAK = 6;
const FRAGMENT = 3;

const BUTTON_STYLE =
  'pagination-page-btn rounded-circle text-center fw-medium bg-transparent';

const Dot = () => (
  <Button size="xs" className={BUTTON_STYLE} disabled isPadding={false}>
    ...
  </Button>
);

function DesktopView({
  totalPage,
  activePage,
  language,
  onClickPage,
}: {
  totalPage: number;
  activePage: number;
  language: string;
  onClickPage: (data: number) => void;
}) {
  const startPages = [1, 2, 3];
  const endPages = [totalPage - 2, totalPage - 1, totalPage];

  return (
    <div className="d-flex justify-contents-between align-items-center gap-4">
      {totalPage > 0 &&
        totalPage <= MAX_PAGE_WITHOUT_BREAK &&
        Array(totalPage)
          .fill(0)
          .map((_, i) => (
            <Button
              key={i}
              className={classNames(BUTTON_STYLE, {
                'pagination-active': activePage === i + 1,
              })}
              onClick={() => onClickPage(i + 1)}
              size="xs"
              isPadding={false}
            >
              {language === 'bn' ? numberToBengali(i + 1) : i + 1}
            </Button>
          ))}

      {totalPage > 0 && totalPage > MAX_PAGE_WITHOUT_BREAK && (
        <>
          <Page
            data={startPages}
            activePage={activePage}
            onClickPage={onClickPage}
            language={language}
          />
          {activePage === FRAGMENT ? (
            <>
              <MidPage
                page={activePage + 1}
                language={language}
                onClickPage={() => onClickPage(activePage + 1)}
              />
            </>
          ) : null}
          {activePage > FRAGMENT && activePage <= totalPage - FRAGMENT ? (
            <>
              <Dot />

              {activePage - 1 !== FRAGMENT ? (
                <MidPage
                  page={activePage - 1}
                  language={language}
                  onClickPage={() => onClickPage(activePage - 1)}
                />
              ) : null}

              <MidPage
                page={activePage}
                language={language}
                active
                onClickPage={() => onClickPage(activePage)}
              />

              {activePage + 1 !== totalPage - 2 ? (
                <MidPage
                  page={activePage + 1}
                  language={language}
                  onClickPage={() => onClickPage(activePage + 1)}
                />
              ) : null}

              <Dot />
            </>
          ) : (
            <Dot />
          )}

          {activePage === totalPage - 2 ? (
            <>
              <MidPage
                page={activePage - 1}
                language={language}
                onClickPage={() => onClickPage(activePage - 1)}
              />
            </>
          ) : null}
          <Page
            data={endPages}
            activePage={activePage}
            onClickPage={onClickPage}
            language={language}
          />
        </>
      )}
    </div>
  );
}

export default DesktopView;
